import { empty } from "../../../constants/placeholders"

/**
 * `specialization`, `location` and `cslb_classification` are typed as arrays
 * but do not always arrive as one — `SubcontractorsList/columns.tsx` has
 * carried an `Array.isArray` guard for exactly these fields since before
 * EAD-1322. Anything that maps or joins one of them needs the same guard, or
 * a single string from the API takes the page down with
 * "specialization.map is not a function".
 */
export const asArray = (value?: string[] | string | null): string[] => {
  if (Array.isArray(value)) return value
  return value ? [value] : []
}

/** The same values rendered as one readable line, or the shared placeholder. */
export const asList = (value?: string[] | string | null): string =>
  asArray(value).join(", ") || empty

/** The compliance value the Needs attention tab sets; it is the tab, not a filter. */
const NEEDS_ATTENTION_TAB = "needs_attention"

interface FilterValues {
  specialization?: string | null
  status?: string | null
  compliance?: string | null
  price_range?: string | null
  rating?: string | null
}

/** Filters a user set from the filter bar, so an empty list can say they hid it. */
export const subcontractorFilterCount = (
  filters?: FilterValues | null
): number =>
  [
    filters?.specialization,
    filters?.status,
    filters?.compliance === NEEDS_ATTENTION_TAB ? null : filters?.compliance,
    filters?.price_range,
    filters?.rating
  ].filter(Boolean).length

/** What "Clear filters" writes: every filter off, the Needs attention tab kept. */
export const clearedSubcontractorFilters = (filters?: FilterValues | null) => ({
  specialization: null,
  status: null,
  compliance:
    filters?.compliance === NEEDS_ATTENTION_TAB ? NEEDS_ATTENTION_TAB : null,
  price_range: null,
  rating: null
})
